import React from "react";

import t from "../../../../Common/utils/translation/translator";

// MSC-1778: Component ComparatorLine must be commonalized
import ComparatorLine from "../../../../Retrofit/components/Devices/BundleComparator/ComparatorLine";

const AxisComparatorSelection = ({ mechanics, compareDatas, ...props }) => {
  // const [showAxis, setShowAxis] = useState(true);

  return (
    <>
      <div className="AxisComparatorSelection" {...props}>
        {/* <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_options.axis")}
          isSectionHeader
          opened={showAxis}
          values={compareDatas.map((bundle) => bundle.name)}
          onClick={() => setShowAxis(!showAxis)}
        />
        {showAxis && (
          <> */}
        <ComparatorLine
          compareData={compareDatas}
          isProductImages
          values={compareDatas.map((bundle) => bundle.axis?.axisGCR)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.product_model")}
          values={compareDatas.map((bundle) => bundle.axis?.axisModel)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.axis_description")}
          values={compareDatas.map((bundle) => bundle.axis?.mediumDescription)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.axis_profile_width_x_height")}
          values={compareDatas.map((bundle) => bundle.axis?.profileDimension)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.axis_profile_with_carriage_width_x_height")}
          values={compareDatas.map((bundle) => bundle.axis?.axisDimension)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.mechanical_drive_element")}
          values={compareDatas.map((bundle) => bundle.axis?.driveType)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.guide_type")}
          values={compareDatas.map((bundle) => bundle.guideType?.guideType)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.feed_constant")}
          values={compareDatas.map((bundle) => bundle.axis?.feedConstant)}
          unit="mm/rev"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.carriage_type")}
          values={compareDatas.map((bundle) => bundle.carriageType?.typeOfCarriage)}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.carriage_length")}
          values={compareDatas.map((bundle) => bundle.carriageType?.lenghtCommercialReference)}
          unit="mm"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.distance_between_two_carriages")}
          values={compareDatas.map(() => mechanics?.distanceBetweenCarriages)}
          unit="mm"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.quantity_of_ball_screw_supports")}
          values={compareDatas.map((bundle) =>
            bundle.calculations?.totalAxisLengthPreCalculations?.preCalcLengthBallScrew.toFixed(0)
          )}
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.distance_between_double_axes")}
          values={compareDatas.map(() => "")}
          unit="mm"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.total_axis_length")}
          values={compareDatas.map((bundle) => bundle.calculations?.axisLength)}
          unit="mm"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.total_axis_weight")}
          values={compareDatas.map((bundle) => bundle.calculations?.axisWeight)}
          unit="kg"
        />
        <ComparatorLine
          compareData={compareDatas}
          title={t("cartesian.ui.axis_selection.repeatability")}
          values={compareDatas.map((bundle) => bundle.axis?.repeatability)}
          unit="mm"
        />
      </div>
      {/* </> */}
      {/* )} */}
    </>
  );
};

export default AxisComparatorSelection;
